export const environment = {
  production: true,
  development: false,
  staging: false,
  version: 'v1',

  //noblaa
  // basicUrl: 'https://gateway.abnaey.com/api',
  basicUrl:"https://gateway-stagev2.abnaey.com/api/v1",


  //firebase config
  firebase: {
    apiKey: "AIzaSyCya5KE2F0gTtWit3lEvzmCJMRF244WPkQ",
    authDomain: "abnayiy-live-chat.firebaseapp.com",
    databaseURL: "https://abnayiy-live-chat-default-rtdb.firebaseio.com",
    projectId: "abnayiy-live-chat",
    storageBucket: "abnayiy-live-chat.appspot.com",
    messagingSenderId: "693138181658",
    appId: "1:693138181658:web:dd82eece846c660ed18ba3",
    measurementId: "G-7FFX20C2RY"
  }
  //ajial
  //basicUrl: 'https://gateway-ajial.abnaey.com/api',
};
